import { isAccess } from './Helpers';

/**
 * Consulta un permiso de pantalla sin que la web se rompa.
 * `isAccess` lanza si el rol no tiene la fila del permiso (p. ej. un rol creado desde el editor
 * de roles, que no ofrece los permisos NOMINA): aquí eso cuenta como "sin permiso".
 * Cada botón consulta exactamente el permiso que exige su endpoint en el backend
 * (`IsAutorized(...)` en `Controllers/Api`); si no, el servidor responde 401 y la web cierra la sesión.
 *
 * @param {Array} access Los permisos del rol (`DataContext`).
 * @param {string} permiso Por ejemplo "CREDITS CREATE".
 * @returns {boolean}
 */
export const tienePermiso = (access, permiso) => {
	try {
		return Boolean(isAccess(access, permiso));
	} catch (e) {
		return false;
	}
};
